class DeliveryController {
  constructor ($state, $http, $filter, $cookies, modalService) {
    this.$http = $http;
    this.$state = $state;
    this.$filter = $filter;
    this.$cookies = $cookies;
    this.modalService = modalService;

    this.request = $state.params.request || this.getRequestCookie();

    if (!this.request) {
      this.$state.go('app.home');
    } else {
      this.request.quote = {};
      this.request.delivery = {};
      this.alerts = [];

      this.getQuoteInfo();
    }
  }

  getRequestCookie () {
    var request = this.$cookies.get('request');
    if (!request) return null;
    if (request == undefined) return null;

    return JSON.parse(request);
  }

  showBookingFee () {
    this.modalService.showBookingFee();
  }

  getQuoteInfo () {
    let selfController = this;
    return this.$http
      .post('/Ajax.aspx/StepQuote', {
        LocalityID: this.request.Locality.ID,
        wasteTypes: this.request.WasteType.ID,
        dateStart: this.$filter('date')(this.request.pickupdate, 'dd/MM/yyyy'),
        dateEnd: this.$filter('date')(this.request.returndate, 'dd/MM/yyyy'),
        PostCode: this.request.PostCode,
        SkipTypes: this.request.fare.ID
      })
      .then(function (response) {
        selfController.request.quote = response.data.data;
      });
  }
  getCategoryText (fare) {
    if (fare.Category.toUpperCase() == 'SKIPTRAILER') {
      return 'The selected item is a mobile skip so no permit is required to park in the street, but it must be parked in compliance with parking regulations';
    }

    return 'The quoted price does not include a council permit that may be required if placed on public land';
  }
  submit () {
    this.alerts = [];
    if (!this.request.delivery.SelectedTown) {
      this.alerts.push({ msg: 'Please select a Suburb.' });
    }

    if (!this.request.delivery.address) {
      this.alerts.push({ msg: 'Street Address is invalid.' });
    }

    if (!this.request.delivery.name) {
      this.alerts.push({ msg: 'Name is invalid.' });
    }

    if (!this.request.delivery.phone && !this.request.delivery.mobile) {
      this.alerts.push({ msg: 'Phone or/and Mobile is invalid.' });
    }

    if (!this.request.delivery.email) {
      this.alerts.push({ msg: 'Email is invalid.' });
    }

    if (
      !this.request.delivery.PrivateLand &&
      !this.request.delivery.PublicLand
    ) {
      this.alerts.push({ msg: 'Please select a placement.' });
    }

    if (this.alerts.length == 0) {
      // Go to payment
      this.request.paymentRef = this.request.quote.paymentRef;
      this.request.delivery.Town = this.request.delivery.SelectedTown;
      this.request.quote = {};
      this.$cookies.put('request', JSON.stringify(this.request));
      console.log(JSON.stringify(this.request));
      this.$state.go('app.payment', {
        request: this.request
      });
    }
  }
}

DeliveryController.$inject = [
  '$state',
  '$http',
  '$filter',
  '$cookies',
  'modalService'
];

export { DeliveryController };



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/delivery/delivery.controller.js
 **/